import { State } from "./types";
import { folder } from "@planzone/dto";

const initialState: State = {
  request: { isFailure: false, isPending: false, isSuccessful: false },
  folder: { ...folder, uuid: "" },
  planzone: "",
};

export { initialState };
